import { render, staticRenderFns } from "./HistoryApprovalTasks.vue?vue&type=template&id=12a14c4b&scoped=true&"
import script from "./HistoryApprovalTasks.vue?vue&type=script&lang=js&"
export * from "./HistoryApprovalTasks.vue?vue&type=script&lang=js&"
import style0 from "./HistoryApprovalTasks.vue?vue&type=style&index=0&id=12a14c4b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a14c4b",
  null
  
)

export default component.exports